import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAboutDotMeComponent } from './simple-icons-about-dot-me.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAboutDotMeComponent ],
    exports:      [ SimpleIconsAboutDotMeComponent ],
    bootstrap:    []
})
export class SimpleIconsAboutDotMeModule {}
